import { unpinGroup as apiUnpinGroup } from 'APP/model/group/groupModel';
import Entities from 'STORE';

interface IUnpinGroupParams {
  groupId: string;
}

export async function unpinGroup(data: IUnpinGroupParams): Promise<void> {
  const group = Entities.GroupsStore.getGroupById(data.groupId);
  if (!group) {
    return;
  }

  const oldPinOrder = group.pinOrder;
  group.pinOrder = 0;

  try {
    const result = await apiUnpinGroup(data);
    if (!result.result) {
      group.pinOrder = oldPinOrder;
    }
  } catch {
    group.pinOrder = oldPinOrder;
  }
}
